const PRODUCT_CUSTOM_CONSTANTS = {
  MODALHEADERTEXT: 'Customize Your',
  CUSTOMIZE_TAG: 'custom',
  MAX_TAG: 'max',
  MAX_ALERT_TEXT_INITIAL: 'maxtextInitial',
  MAX_ALERT_TEXT_END: 'maxtextEnd',
  CLOSE_ALERT_TEXT: 'selectionNotSaved',
  ITEM_QUANTITY: 0,
  CUSTOMIZE_BUTTON_TEXT: 'customise',
  EDIT_BUTTON_TEXT: 'edit',
  DISMISS_CHANGES_ALERT_TEXT: 'dismissChangesAlert',
  DISMISS_SELECTIONS: 'dismissSelections',
};
export default PRODUCT_CUSTOM_CONSTANTS;
